import LoginController from 'login.controller';

export default {
	templateUrl: 'src/auth/components/login/login.template.html',
	controller: LoginController
};